import { KanbanObjectType, KanbanQueueView, KanbanTaskView } from '@nexelem/graphne-api';
import { createSelector } from 'reselect';
import { selectProductionQueues } from '../Kanban';

export type KanbanSearchResult = {
  queue: KanbanQueueView;
  task: KanbanTaskView;
  batchName?: string;
};

const getSearchableText = ({ productName, name, orders, productionOrderDetails }: KanbanTaskView) =>
  [
    productName,
    name,
    orders?.map((order) => order.orderId).join(', '),
    productionOrderDetails?.number,
    productionOrderDetails?.externalId,
  ].join(' ');

export const searchKanbanTasks = (search: string) =>
  createSelector([selectProductionQueues, () => search], (productionQueues) =>
    productionQueues
      .flatMap(({ queue, tasks = [] }) =>
        tasks.flatMap<KanbanSearchResult>((task) =>
          task.tpe === KanbanObjectType.Batch
            ? (task.tasks ?? []).map((batchTask) => {
                return { queue, task: batchTask, batchName: task.name };
              })
            : [{ queue, task }],
        ),
      )
      .filter(({ task }) => getSearchableText(task).toLowerCase().includes(search.toLowerCase())),
  );
